import {CmsUserSignature, DateAndTimeFormat, GameRawData, ITokenInfo} from './sdk.service.interface';
import {IRunningGameHandler} from '../games/running-game-handler.interface';
import {IUsefulLinkSdkData} from "../user-menu/useful-links/useful-link-data.interface";
import {IAutoLoginParams} from '../../../common/interfaces/autologin-params.interface';
import {BalanceType} from "../../../common/const/wallet_balance_type";
import IStructuredLoggingService from "../../../common/interfaces/structured-logging-service-interface";
import {SdkOverlayZIndex} from "../../../common/interfaces/sdk-overlay-z-index";
import {ICashierWidgetsEligibilityDetails} from "../../../common/interfaces/cashier-widgets-eligibility-details.interface";
import {IGeoLocationInfo} from "../../../common/interfaces/geo-location-info.interface";
import {ILegacyCompanyViewModel} from "../companies/legacy-company-view-model.interface";
import {GamingHistoryRecordRawData} from "../gaming-history/gaming-history.service.interfce";
import { IAbTestingFeatureProperties } from '../../../common/interfaces/ab-testing-interface';
import {IHybridService} from "../hybrid/hybrid.service.interface";
import {ILegacyRegulation} from "../regulation/legacy-regulation.interface";
import {NullableNumber, NullableString} from "../../../common/types/nullable-types";
import ISdkGnwpService from "../../../sdk/src/services/gnwp/gnwp_service_interface";
import {IScriptLoaderService} from "../scrip-loader/script-loader.service.interface";
import {IFreePlayVoucherData} from "../../../common/interfaces/free-play/free-play-voucher-data.interface";
import {ISdkMessageButtonOptions} from '../../../common/interfaces/sdk-message-button-options';
import IStateOfResidence from "../../../common/interfaces/state-of-residence.interface";

interface OnEventParams {
  eventName: string;
  callback: Function;
  context: any;
}

interface SendAnalyticsParams {
  category: string;
  action: string;
  label: string;
  value: string;
  omitStructuredLogger?: boolean
}

interface GetAIListResponse {
  aiGameTypesArray: number[];
  aiEngine: string;
}




export const CGP_EVENTS_NAMES = {
  ON_BEFORE_OAUTH_STATE_CHANGE: 'ON_BEFORE_OAUTH_STATE_CHANGE',
  OAUTH_STATE_CHANGE: 'OAUTH_STATE_CHANGE',
  RECENTLY_PLAYED_GAMES_UPDATED: 'RECENTLY_PLAYED_GAMES_UPDATED',
  AUTOLOGIN_SUCCESS: 'AUTOLOGIN_SUCCESS',
  AUTOLOGIN_FAILED: 'AUTOLOGIN_FAILED',
  DEEPLINK_RECEIVED: 'DEEPLINK_RECEIVED',
  GAME_OPEN: 'GAME_OPEN',
  CLOSE_GAME: 'CLOSE_GAME',
  PLAYER_ACTION: 'PLAYER_ACTION',
  LOGIN_FORM_OPEN: 'LOGIN_FORM_OPEN',
  LOGIN_FORM_CLOSE: 'LOGIN_FORM_CLOSE',
  TOKEN_LIFETIME_EXPIRED: 'TOKEN_LIFETIME_EXPIRED',
  LIVE_TABLES_UPDATE: 'LIVE_TABLES_UPDATE',
  GAMES_QUESTIONNAIRE_COMPLETED: 'GAMES_QUESTIONNAIRE_COMPLETED',
  FREE_PLAY_UPDATED: 'FREE_PLAY_UPDATED',
  LIVE_FEEDS_JACKPOT_AMOUNTS_UPDATED: 'LIVE_FEEDS_JACKPOT_AMOUNTS_UPDATED',
  LIVE_FEEDS_STATE_JACKPOTS_UPDATED: 'LIVE_FEEDS_STATE_JACKPOTS_UPDATED',
  GAME_POPUP_SHOW: 'GAME_POPUP_SHOW',
  BALANCE_UPDATED: 'BALANCE_UPDATED',
  REALITY_CHECK_OPENED: 'REALITY_CHECK_OPENED',
  REALITY_CHECK_CLOSED: 'REALITY_CHECK_CLOSED',
  REGISTRATION_COMPLETED: 'REGISTRATION_COMPLETED',
  DAILY_DEAL_REMOVE_INDICATION: 'DAILY_DEAL_REMOVE_INDICATION',
  OMG_AWAITING_MESSAGES_UPDATED: 'OMG_AWAITING_MESSAGES_UPDATED',
  APP_RESUMED: 'APP_RESUMED',
  APP_PAUSED: 'APP_PAUSED',
  EXTERNAL_LINK_CLOSED: 'EXTERNAL_LINK_CLOSED',
  TOUCH_ID_STATE_CHANGED: 'TOUCH_ID_STATE_CHANGED',
  OMG_DISPLAYED: 'OMG_DISPLAYED',
  SESSION_EVENT_PLAYER_BURNOUT_MESSAGE_RECEIVED: 'SESSION_EVENT_PLAYER_BURNOUT_MESSAGE_RECEIVED',
  LIVE_GAME_SWITCHED: 'LIVE_GAME_SWITCHED',
  PROMOTIONS_CHANGED: 'PROMOTIONS_CHANGED',
  DEPOSIT_WIDGET_CLOSED : 'DEPOSIT_WIDGET_CLOSED',
};


export interface DeviceInfo {
  os: {
    name: string;
    version: number;
    isMobileOS: boolean;
    isIOS: boolean;
    isAndroid: boolean;
    isPC: boolean;
    isMacOS: boolean;
  };
  browser: {
    name: string;
    version: number;
    isSafari: boolean;
    isChrome: boolean;
    isFirefox: boolean;
  };
  model: {
    isIphone: boolean;
    isIpad: boolean;
  };
  hybrid: {
    isHybrid: boolean;
    isEmbedded: boolean;
  };
  feature: {
    isTouch: boolean;
  };
  isProgressiveWebApp: boolean;
  isStandalone: boolean;

  /** @deprecated */
  isMobile(): boolean;
  /** @deprecated */
  isTablet(): boolean;
}

export interface CGPEventSubscription {
  off();
}


export interface GetAutoLoginTokenResponse {
  token: string;
}

export interface GetPlatformTokenResponse {
  token: string;
}

export interface IDailyDealCampaign {
  MarketingCampaignId: string;
}


export interface CgpSkinInfo {
  getBrandName(): string;
  getPlatformSystemID(): number;
  getClientPlatform(): string;
  getVersion(): string;
  getCulture(): string;
  shouldPreventLoginToEnforceHybridAppForMobileWeb(): boolean;
  shouldPreventOpenGameForMobileWebApp(): boolean;
  getMinimumAge(): number;
  getSafeToPlayURL(): NullableString;
}

export interface ISdkUtils {
  getGuid():string
  arraysAreEqual(arr1: any[], arr2: any[]): boolean;
}

export interface ISdkRegulationService {
  isUSRegulation(): boolean;
  getRegulationCode(): number;
  getSessionCooldownConfig(): {featureEnabled: boolean; cooldownTime: string};
  shouldShowPlayerLimitsToaster(): boolean;
  getErrorMessage(errorCode: number): NullableString;
  forceDemoButton(): boolean;
}

export interface IOpenHistoryGameRequest {
  historyRecordData: GamingHistoryRecordRawData;
  gameType: number,
  gameName: string,
  gameRoundId: string,
  gameRoundDate: string;
}

export interface ICgpSdk {
  closeRunningGame(): void;
  countPlayerChallenges(): number;
  getRegulationDateAndTimeFormat(): DateAndTimeFormat;
  createComponentRenderer(componentId: string): any;
  device(): DeviceInfo;
  displayHybrid?: () => void;
  isHybridEmbeddedGame(gameType: number): boolean;
  openHybridLink(url: string): void;
  format$$$(value: number, withDecimal: boolean);
  getBalance();
  getAIList(maxGames: number, filterOutRecentlyPlayedGames: boolean, numberOfRecentlyPlayedGameToFilterOut: number): Promise<GetAIListResponse>;
  getAINewGamesList(maxGames: number, filterOutRecentlyPlayedGames: boolean, numberOfRecentlyPlayedGameToFilterOut: number): Promise<GetAIListResponse>;
  getAutoLoginToken(): Promise<GetAutoLoginTokenResponse>;
  getPlatformToken(): Promise<GetPlatformTokenResponse>;
  getFirebaseToken(): string;
  getBrandID(): number;
  getCorrelatedGames(gameType: number, numberOfGames: number): Promise<number[]>;
  getExternalBrandCallbackURL(): string;
  getExternalBrandCallbackURLMethod(): string;
  getGamesInfo(gameTypes: number[]): Promise<GameRawData>;
  getGamesThemes(): Record<number, string>;
  getGamesInfoForHistory(gameTypes: number[]): Promise<GameRawData>;
  getGRSEnvironments(): Promise<any>;
  getDepositWidgetEligibilityDetails(): ICashierWidgetsEligibilityDetails;
  getCashoutWidgetEligibilityDetails(): ICashierWidgetsEligibilityDetails;
  getSourceSubBrandName(): string;
  getSubBrandID(): number;
  dateAndTimeFormat(): DateAndTimeFormat;
  getUserData(): any;
  getUsername(): string;
  getSessionId(): string;
  getUserSegments(): CmsUserSignature;
  isAuthorized(): boolean;
  isLoginFromRegistration():boolean;
  getCGPMaxOverlayZIndex(): number;
  structuredLoggingService():IStructuredLoggingService;
  isVIP(): boolean;
  logout(): Promise<void>;
  menuActionExecute(key: string): void;
  menuJSON(): Promise<IUsefulLinkSdkData[]>;
  onEvent(params: OnEventParams): CGPEventSubscription;
  routeChanged(): void;
  openExternalLink(params: any): Promise<void>;
  openResponsibleGamingLink(view?:number):void;
  isGameRunning(): boolean;
  openGame(options: any): Promise<IRunningGameHandler>;
  openInNewWindow(url: string, features?: string): void;
  openLoginForm(options: any): Promise<void>;
  sendAnalytics(params: SendAnalyticsParams);
  setAutoLoginToken(autologinToken: any): void;
  startLiveTableFeeds(): void;
  stopLiveTableFeeds(): void;
  refreshThirdPartyVouchers(): Promise<IFreePlayVoucherData[]>;
  getAbTestingDataForFeature(featureName: string): IAbTestingFeatureProperties;
  getAbTestingData(): { [key: string]: IAbTestingFeatureProperties };
  waitForAnonymousAbTestingData(): Promise<void>;
  getCurrentServerDate(): Date;
  closeCurrentDetailHistory(): void;
  getRichPageUrl(campaignId: string): string;
  getDailyDealCampaigns(): Promise<IDailyDealCampaign[]>;
  getBankroll(balanceType: BalanceType, plainNumber?: boolean): string | number;

  getJackpotsWithState(): unknown;
  getJackpotAmountByGameType(gameType: number): NullableNumber;
  getNumberOfAwaitingMessages(): number;
  openOmgAwaitingMessages(): void;
  getFreeplayVouchers(): Promise<number>;

  loadSafezoneSdk(): Promise<void>;
  getProductPackage(): number;

  getSkin(): CgpSkinInfo;
  runAutoLogin(autoLoginParams: IAutoLoginParams):unknown;

  getUtils(): ISdkUtils;
  onOrbitInitComplete(): void;

  getEnvironment(): string;
  pushDataToDataLayer(data:{}): void;
  getCountryName(): string;
  getCountryIso3(): string;
  getSupportedStates(): IStateOfResidence[];
  getWrongLocationDetectionPath(): string;
  getTrendingRecommendedGamesForPlayer(listTypeId: number[]):Promise<{[key:number] : number[]}>;

  showToaster(toasterData: {}): unknown;
  getRegulationService(): ISdkRegulationService;

  waitForAutologin(): Promise<void>;
  httpPost<TResponse>(url: string, requestData: unknown): Promise<TResponse>;
  httpGet<TResponse>(url: string, requestData: unknown): Promise<TResponse>;
  getConfigs(): any;
  loadScript(url: string, tagId?: string): Promise<void>;
  getRefreshToken(): string;
  getCurrencyIso3(): string;
  readonly overlayZIndex: SdkOverlayZIndex;
  getGoogleClientID(): string;
  isInAutologin(): boolean;
  fireDepositWidgetClosed(): void;
  getToken(): ITokenInfo | null;

  continuePlayingCurrentGame(): void;
  stopCurrentGameAutoplay(): void;
  openHistoryLink(): void;
  isDepositWidgetSupportedByHybrid(): boolean;
  getGeoLocationInfo(): Promise<IGeoLocationInfo | null>;
  getDownloadAppLink(): string;
  promptPushNotificationPermissionRequest(): void;
  openPopUpOnSecondWebView(content : string, timeout : number) : void;
  closePopUpOnSecondWebView() : void;
  bringOmgToFront(): void;
  getBurnoutAnimationZIndex(): number;
  getCompanyByName(name: string): Promise<ILegacyCompanyViewModel>;
  openHistoryGame(request: IOpenHistoryGameRequest): Promise<void>
  readonly hybrid: IHybridService;
  readonly currentRegulation: ILegacyRegulation;
  getCurrentBrowserTabId(): string;
  readonly hasOpenOverlays: boolean;
  readonly gnwp: ISdkGnwpService;
  readonly scriptLoader: IScriptLoaderService;
  startGeoLocationOnOpenRealGame(): Promise<void>;
  getButtonsForNonRetryGeoFlow(): Partial<ISdkMessageButtonOptions>[];
  stopGameTimeReminders(): void;
  isEligibleForGameGeoRetry(): boolean;
  getRetryMessageButtons(analyticsLabel: string, resolve?, reject?): Partial<ISdkMessageButtonOptions>[];
}
